export default __webpack_public_path__ + "static/3-f826e304eb5756202471db944687840d.png";